import React, { useEffect, useState } from 'react';
import {
  AdminContainer,
  AdminTitle,
  AdminDescription,
  ActionsGrid,
  AdminButton,
  DisabledAdminButton,
  ComingSoonLabel,
} from './Admin.Styles';

const Admin: React.FC = () => {
  const [welcomeName, setWelcomeName] = useState<string | null>(null);

  useEffect(() => {
    const name = sessionStorage.getItem('admin_welcome_name');
    if (name) {
      setWelcomeName(name);
      sessionStorage.removeItem('admin_welcome_name');
    }
  }, []);

  return (
    <AdminContainer>
      <AdminTitle>Admin Controls</AdminTitle>
      {welcomeName ? (
        <div style={{ textAlign: 'center', marginBottom: '1.5rem', color: 'var(--primary-light)' }}>
          Welcome, {welcomeName}
        </div>
      ) : null}
      <AdminDescription>
        Internal tools for managing players, fixtures, and game sheets.
      </AdminDescription>

      <ActionsGrid>
        <AdminButton to="/admin/add-player">
          <span>Add a Player</span>
        </AdminButton>
        <AdminButton to="/admin/amend-player">
          <span>Amend a Player</span>
        </AdminButton>

        <AdminButton to="/admin/delete-player">
          <span>Remove a Player</span>
        </AdminButton>

        <AdminButton to="/admin/add-fixture">
          <span>Add a Fixture</span>
        </AdminButton>

        <AdminButton to="/admin/add-team-logo">
          <span>Add Team Logo</span>
        </AdminButton>

        <DisabledAdminButton>
          <span>Remove a Fixture</span>
          <ComingSoonLabel>Coming soon</ComingSoonLabel>
        </DisabledAdminButton>

        <AdminButton to="/admin/game-sheet">
          <span>Submit a Game Sheet</span>
        </AdminButton>
      </ActionsGrid>
    </AdminContainer>
  );
};

export default Admin;

